<template>
    <section class="row-12">
       <p>test</p>
    </section>
</template>

<script>
    export default {
        components: {
        },
        data: () => {
            return {
            }
        },
        methods: {
        },
        mounted: function () {
        }
    }
</script>
<style>
    .left-friends-list,
    .right-friends-list {
        min-width: 200px;
        max-height: 260px;
        overflow-y: auto;
    }

    #shareModal .card:hover {
        cursor: pointer;
    }

    .header-list {
        margin-bottom: 20px;
    }

    .share-titles {
        align-items: center;
        justify-content: center;
        display: flex;
    }

    .modal-body .card {
        width: 300px;
        margin-bottom: 10px;
    }

    .modal-body .row-12 {
        width: 670px;
    }

    .card .card-body {
        padding: 10px;
    }

    .deleteFriend {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        height: 12px;
        width: 12px;
        padding: 5px;
        background: #6e52a8;
        color: white;
        cursor: pointer;
        border-radius: 50%;
        transition: all .2s;
    }

    .deleteFriend:hover {
        transform: rotate(90deg);
    }

    .deleteFriend i {
        margin: 0;
    }

    @media only screen and (max-width: 960px) {
        .modal-body .center-flex-a {
            flex-direction: column;
        }

        .header-list {
            flex: 1;
            text-align: center;
            padding: 10px;
            margin-bottom: 0px;
        }

        .header-list:hover {
            background: #6E53A8;
            color: white !important;
            cursor: pointer;
        }

        .left-friends-list,
        .right-friends-list {
            padding-right: 20px;
        }

        .modal-body .row-12 {
            width: auto;
        }
    }
</style>
